import { EsignEffects } from './esign.effects';

export const esignEffects = [EsignEffects];
